export const termsData = {
    3: {
        value: 3,
        text: 'CALCULATOR_FULL_MONTHS_01'
    },
    6: {
        value: 6,
        text: 'CALCULATOR_FULL_MONTHS'
    },
    12: {
        value: 1,
        text: 'CALCULATOR_YEAR'
    },
    24: {
        value: 2,
        text: 'CALCULATOR_YEARS'
    },
    36: {
        value: 3,
        text: 'CALCULATOR_YEARS'
    },
    60: {
        value: 5,
        text: 'CALCULATOR_YEARS_01'
    },
    240: {
        value: 20,
        text: 'CALCULATOR_YEARS_01'
    }
};

export const termsDataMonths = {
    3: {
        value: 3,
        text: 'CALCULATOR_FULL_MONTHS_01'
    },
    6: {
        value: 6,
        text: 'CALCULATOR_FULL_MONTHS'
    },
    9: {
        value: 9,
        text: 'CALCULATOR_FULL_MONTHS'
    },
    12: {
        value: 12,
        text: 'CALCULATOR_FULL_MONTHS'
    },
    15: {
        value: 15,
        text: 'CALCULATOR_FULL_MONTHS'
    },
    24: {
        value: 24,
        text: 'CALCULATOR_FULL_MONTHS_01'
    },
    36: {
        value: 36,
        text: 'CALCULATOR_FULL_MONTHS'
    },
    60: {
        value: 60,
        text: 'CALCULATOR_FULL_MONTHS'
    },
    240: {
        value: 240,
        text: 'CALCULATOR_FULL_MONTHS'
    }
};
